document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('click', (event) => {
        const button = event.target.closest('[name="checkout"], [name="goto_pp"], [name="goto_gc"]');
        if (!button) return;

        const agreeCheckbox = document.getElementById('agree');
        if (!agreeCheckbox) return console.error("Checkbox with id 'agree' not found.");

        if (!agreeCheckbox.checked) {
            alert(Shopify?.translations?.cartAcceptTerms || "Please accept the terms and conditions.");
            event.preventDefault();
            return;
        }

        const form = button.closest('form');
        if (!form) return console.error("No form found for the clicked button.");

        form.submit();
    });
});
